export const EN = 'en';
export const LB = 'lb';
export const USER = 'user';
export const US = 'US';
export const SHIPPING = 'shipping';
